<template>
    <div class="login-page">
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="#" class="h1"><b>SendAll</b></a>
                </div>
                <div class="card-body">
                    <div class="form-group" :class="{'is-invalid':errors.has('email')}">
                        <label class="control-label">{{ $t('attributes.email')}}:</label>
                        <input v-model="auth.email" v-validate="{required:true, email:true}" type="email"
                            :placeholder="$t('words.type_email')" class="form-control" name="email" autofocus>
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                    </div>
                    <div class="form-group" :class="{'is-invalid':errors.has('password')}">
                        <label class="control-label">{{ $t('attributes.password')}}</label>
                        <input v-model="auth.password" v-validate="{required:true, min:6}" ref="password"
                            type="password" :placeholder="$t('attributes.password')" class="form-control"
                            name="password">
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
                    </div>
                    <div class="form-group" :class="{'is-invalid':errors.has('password_confirmation')}">
                        <label class="control-label">Confirmar Senha</label>
                        <input v-model="auth.password_confirmation"
                            v-validate="auth.password.length > 0 ? 'required|confirmed:password' : ''"
                            :placeholder="'Confirmar Senha'" type="password" class="form-control"
                            name="password_confirmation">
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('password_confirmation')}}</div>
                    </div>
                    <br>
                    <div class="row justify-content-between m-0">
                        <router-link to="/login" class="btn btn-default">
                            <i class="fa fa-times"></i> {{$t('words.back')}}
                        </router-link>
                        <button type="button" @click="submit" :disabled="loading" class="btn btn-primary">
                            <i class="fa fa-check"></i> {{$t('words.save')}} <i v-show="loading"
                                class="fa fa-circle-o-notch fa-spin"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-undef */
export default {
    props: ['status'],
    data() {
        return {
            auth: {
                email: '',
                password: '',
                password_confirmation: '',
                token: '',
                remember: false
            },
            loading: false,
            loginMsg: '',
            message: '',

        };
    },
    beforeMounted() {
        this.$auth.check().then(response => {
            if (response) {
                this.$router.push({
                    name: 'dashboard'
                });
            }
        });
    },
    methods: {
        submit() {
            this.$validator
                .validateAll(['email', 'password', 'password_confirmation'])
                .then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.loading = true;
                    this.auth.token = this.$route.params.token;
                    this.$auth
                        .resetPassword(this.auth)
                        .then(response => {
                            this.loading = false;
                            if (response.data.status !== undefined) {
                                toastr({
                                    icon: 'success',
                                    title: response.data.message
                                });
                                this.$auth
                                    .login(this.auth)
                                    .then(response => {
                                        this.loading = false;
                                        if (response.data.access_token) {
                                            window.location.href = "/dashboard";
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                        this.loading = false;
                                    });
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            if (error.response.data.status !== undefined) {
                                toastr({
                                    icon: 'error',
                                    title: error.response.data.message
                                });
                            }
                        });
                });
        },
    }

};
</script>

<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
    #app .container {
        max-width: 100%;
    }

    #first {
        height: 100vh;
        background-color: darkgray !important;
    }

    img {
        width: 100%;
        height: 100%;

        position: fixed;
        left: 0;
        z-index: -999;
    }

    /* ----- SECTION-LOGIN ----- */
    #section-login {
        width: 100%;
        height: 100vh;
        position: absolute;
        right: 3vh;
    }


    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }

    @keyframes home {
        from {
            transform: translateX(30vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .router-anim-bg-enter-active {
        animation: coming-bg 0.6s;
        animation-duration: 1s;
    }

    .router-anim-bg-leave-active {
        animation: going-bg 0.6s;
        animation-duration: 1s;
    }

    @keyframes coming-bg {
        from {
            transform: translateX(100vw);
        }

        to {
            transform: translateX(0);
        }
    }

    @keyframes going-bg {
        from {
            transform: translateX(0);
        }

        to {
            transform: translateX(-100vw);
        }
    }

    /* ----- SECTION-HOME ----- */
    #section-home {
        color: #fff;
        width: 100vw;
    }

    #section-home ul {
        list-style: none;
        align-items: center;
        justify-content: space-between;
    }

    #section-home li a {
        padding: 1rem;
        transition: all 0.3s;
        font-size: 16px;
        color: #fff;
        font-family: "Montserrat";
        font-weight: 300;
        line-height: 1.3;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
    }

    #section-home li:hover a {
        color: #ff7f00;
        text-decoration: underline;
        border-radius: 5px;
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    @media screen and (max-width: 767px) {
        #section-login {
            max-width: 50%;
            right: auto;
        }
    }

    @media screen and (max-width: 576px) {
        #section-login {
            max-width: 100%;
            right: 0;
        }
    }

    @media screen and (max-width: 991px) {
        img {
            width: auto;
        }

        @keyframes home {
            from {
                transform: translateX(100vw);
            }

            to {
                transform: translateX(0);
            }
        }
    }

    #cookies {
        border-radius: 5px;
        bottom: 1rem;
        left: 0;
        z-index: 9999;
        -webkit-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        -moz-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
    }

    .anim-cookies-enter-active {
        animation: cookies 0.6s;
    }

    .anim-cookies-leave-active {
        animation: cookies 0.6s;
        animation-direction: reverse;
    }

    @keyframes cookies {
        from {
            transform: translateY(10vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }
</style>